import { render, staticRenderFns } from "./PartyHistory.vue?vue&type=template&id=5af80a4d&scoped=true"
import script from "./PartyHistory.vue?vue&type=script&lang=js"
export * from "./PartyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af80a4d",
  null
  
)

export default component.exports